import React, { useState, useContext } from 'react';
import axios from 'axios';
import Logo from "../components/assets/login-avator.jpg";
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../utilities/AuthContext';

const Login = () => {
    const navigate = useNavigate();
    const { setUser } = useContext(AuthContext);
    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (!formData.email || !formData.password) {
            setLoading(false);
            return setError("Email and password are required");
        }

        try {
            const response = await axios.post('https://backend-livestream-production.up.railway.app/api/login-user', {
                email: formData.email.trim(),
                password: formData.password.trim()
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.data.ok === 1) {
                const userData = {
                    email: response.data.email,
                    username: response.data.username,
                    company_name: response.data.company_name,
                    role: response.data.rank_,
                    status: response.data.status
                };

                // Store in localStorage
                localStorage.setItem('user', JSON.stringify(userData));
                
                // Update context immediately
                setUser(userData);

                // Redirect based on status
                if (response.data.status === "PENDING") {
                    navigate("/add-personal-detail");
                } else {
                    navigate("/"); // Explicitly go to dashboard
                }
            } else {
                setError(response.data.error || "Login failed. Please try again.");
            }
        } catch (err) {
            console.error("Login error:", err);
            if (err.response) {
                setError(err.response.data.error || 
                       err.response.data.message || 
                       "Invalid credentials. Please try again.");
            } else if (err.request) {
                setError("No response from server. Please check your connection.");
            } else {
                setError("Login failed. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
            <div className='card'>
                <div className='card-body'>
                    <div className='row'>
                        <div className='col-md-6 d-flex justify-content-center'>
                            <img src={Logo} alt="Login Avatar" className="img-fluid rounded"
                                 style={{ maxWidth: '100%', height: 'auto' }} />
                        </div>
                        <div className='col-md-6'>
                            <div className="card shadow-lg p-4" style={{ maxWidth: '400px', width: '100%' }}>
                                <h2 className="text-center mb-4">Sign In</h2>
                                {error && (
                                    <div className="alert alert-danger" role="alert">
                                        {error}
                                    </div>
                                )}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Email</label>
                                        <input 
                                            type="email" 
                                            className="form-control" 
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange} 
                                            required 
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Password</label>
                                        <input 
                                            type="password" 
                                            className="form-control" 
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange} 
                                            required 
                                        />
                                    </div>
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary w-100"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Logging in...
                                            </>
                                        ) : "Login"}
                                    </button>
                                </form>
                                <div className="text-center mt-3">
                                    <small>Don't have an account? <Link to="/register">Sign up</Link></small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;